import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_SIGN_FORM_SIGNER_CAROUSEL_COLORS_EXPERIMENT = defineFcm('sign_form_signer_carousel_colors_experiment')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string', optional: true },
			},
		}),
	)
	.withDefault({ experimentName: undefined })
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		context: 'Petition Details Page Mobile Sign Modal Recent Signers Carousel',
		description:
			'Experiment Service experiment name for the sign form signer carousel colors experiment, and its ' +
			'own enablement flag: an unset/empty value means the experiment does not run. No merging across ' +
			'scopes — whichever of locale, country or global has an entry wins the whole value (locale beats ' +
			'country beats global), so a country entry (the top-8 rollout targeting: US, GB, DE, AU, CA, FR, ' +
			'IT, JP) is fully independent of any other scope’s entry, including the global one; there is no ' +
			'single kill switch that reaches an already-configured scope. It has no default, so no scope runs ' +
			'until its own experimentName is set. It is also the `?exo.<name>=<variation>` override key, which ' +
			'therefore changes with each iteration.',
		template: { experimentName: 'sign_form_signer_carousel_colors_experiment' },
	});
